import Br from "./br.png";
import Mx from "./mx.png";
import Eua from "./eua.png";

export const BrBrand = Br;
export const MxBrand = Mx;
export const EuaBrand = Eua;
